import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createProduct } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function ProductCreate({ modal_list, setmodal_list, tog_list, fetchData }) {
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      const body = {
        product_name: data.product_name,
        hsn_code: data.hsn_code,
        gst_percent: data.gst_percent,
        created_by: getSessionData("user_id"),
      };

      const response = await createProduct(body);

      if (response.statusCode === 200) {
        successToastify("Product Created Successfully!");
        fetchData();
        setmodal_list(false);
        reset();
      } else {
        // Handle error
        errorResponseHandler(response);
      }
    } catch (error) {
      // Handle error
      console.error("Error adding product:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal
        isOpen={modal_list}
        toggle={() => {
          tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          toggle={() => {
            tog_list();
          }}
        >
          Add Product
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="productName" className="form-label">
                Product Name
              </label>
              <input
                type="text"
                id="productName"
                className="form-control"
                placeholder="Enter Product Name"
                {...register("product_name", {
                  required: "Product Name is required",
                })}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="hsn_code" className="form-label">
                HSN Code
              </label>
              <input
                type="text"
                id="hsn_code"
                className="form-control"
                placeholder="Enter HSN Code"
                {...register("hsn_code", {
                  required: "HSN Code is required",
                })}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="gst_percent" className="form-label">
                GST Percent
              </label>
              <input
                type="text"
                id="gst_percent"
                className="form-control"
                placeholder="Enter GST Percent"
                {...register("gst_percent", {
                  required: "GST Percent is required",
                })}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Add Product
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

// Add prop types for validation
ProductCreate.propTypes = {
  modal_list: PropTypes.bool.isRequired, // Indicates whether the modal is open
  setmodal_list: PropTypes.func.isRequired, // Function to toggle modal visibility
  tog_list: PropTypes.func.isRequired, // Function to toggle the modal
  fetchData: PropTypes.func.isRequired, // Function to fetch the updated product data
};

export default ProductCreate;
